import { creatUUId } from '../../redux/helper/CreateUUID';

export const awsRegion = process.env.REACT_APP_AWS_REGION;
export const s3Bucket = process.env.REACT_APP_S3_BUCKET;
export const accessKeyId = process.env.REACT_APP_ACCESS_KEY_ID;
export const secreteAccessKey = process.env.REACT_APP_SECRETE_ACCESS_KEY;
export const appStage = process.env.REACT_APP_STAGE;
export const Certificateconfig = {
    bucketName: s3Bucket,
    region: awsRegion,
    accessKeyId,
    dirName: `certificate/${creatUUId()}`,
    secretAccessKey: secreteAccessKey,
};
